export default __webpack_public_path__ + "static/media/task_class.7b7cb63e.svg";